export default __webpack_public_path__ + "static/media/CV6.e3e6155c.jpg";